import React, { useEffect, useState } from 'react';
import MapGta from '../../maps/MapGta';
import MapWorld from '../../maps/MapWorld';
import { NotificationManager } from 'react-notifications';
import { locales } from '../../../../translations/locales';
import SigData from './SigData';
import { _$ } from '../../../../controllers/dom';
import SigGta from './SigGta';

const Sig = (props) => {
    const { data, theme, locale, ModuleRP } = props;
    const [map, setMap] = useState(data.options.sig.type || data.options.sig.options[0]);
    const [selectedGtaMap, setSelectedGtaMap] = useState(data.options.sigData.gtamap || 'satellite');
    const [mapObject, setMapObject] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [departments, setDepartments] = useState(data.options.sigData.departments);
    // const [clickData, setClickData] = useState(null);

    const selectMapType = () => {
        ModuleRP.config.sigMap(map, selectedGtaMap);
        NotificationManager.success(locales[locale].sig.selectedMapWithSuccess);
    };

    const selectDepartment = () => {
        const department = _$('department').value;
        if (departments.includes(department)) return NotificationManager.error(locales[locale].sig.departmentAlreadySelected);
        setDepartments([...departments, department]);
        if (department) {
            ModuleRP.config.sigAddDepartment(department);
            NotificationManager.success(locales[locale].sig.addedSuccessfully);
        }
    };

    const deleteDepartment = (department) => {
        setDepartments(departments.filter((dept) => dept !== department));
        ModuleRP.config.sigRemoveDepartment(department);
        if (mapObject.getLayer('department-fill' + department)) mapObject.removeLayer('department-fill' + department);
        if (mapObject.getLayer('department-label' + department)) mapObject.removeLayer('department-label' + department);
        if (mapObject.getSource('department' + department)) mapObject.removeSource('department' + department);
        NotificationManager.success(locales[locale].sig.deletedSuccessfully);
    };

    useEffect(() => {
        data.options.sigData.gtamap = selectedGtaMap;
    }, [map, departments, selectedGtaMap]);

    return (
        <div className={`container ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
            <h1>{locales[locale].sig.sig}</h1>
            {
                data.options.sig.active ? (
                    <>
                        <select
                            onChange={(e) => setMap(e.target.value)}
                            className='form-control w-25 m-1'
                            defaultValue={map}
                        >
                            {data.options.sig.options.map((opt, index) => (
                                <option key={index} value={opt}>
                                    {locales[locale].shop[opt]}
                                </option>
                            ))}
                        </select>
                        <button className='btn btn-primary' onClick={selectMapType}>
                            {locales[locale].sig.validMap}
                        </button>
                    </>
                ) : (
                    <div className='row'>
                        <div className={`col-4 m-5 p-1 border border-solid border-${theme === 'DARK' ? 'light' : 'dark'} 
                                    ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
                            <h2>{locales[locale].shop.sig}</h2>
                            <p>{locales[locale].shop.sigDesc.split('<br />').map((text, index) => (
                                <React.Fragment key={index}>
                                    {index > 0 && <br />}
                                    {text}
                                </React.Fragment>
                            ))}</p>
                            <select
                                className='form-control'
                                id='select-option'
                                onChange={(e) => setSelectedOption(e.target.value)}
                            >
                                <option
                                    value={false}
                                >
                                    {locales[locale].shop.selectOption}
                                </option>
                                <option
                                    value={'gtaMap'}
                                >
                                    {locales[locale].shop.gtaMap}
                                </option>
                                <option
                                    value={'worldMap'}
                                >
                                    {locales[locale].shop.worldMap}
                                </option>
                            </select>
                            <button
                                className='btn btn-sm btn-success float-right'
                                id='btn-buyOption-sig'
                                onClick={() => ModuleRP.buyOption('sig', selectedOption)}
                            >
                                {locales[locale].shop.buySig} (500 Extras)
                            </button>
                        </div>
                    </div>
                )
            }
            {
                data.options.sig.active && map === 'worldMap' ? (
                    <SigData
                        locale={locale}
                        theme={theme}
                        mapObject={mapObject}
                        selectDepartment={selectDepartment}
                        departments={departments}
                        deleteDepartment={deleteDepartment}
                    />
                ) : ModuleRP.userName === 'Administrateur' ? (
                    <>
                        <SigGta
                            selectedGtaMap={selectedGtaMap}
                            setSelectedGtaMap={setSelectedGtaMap}
                        />
                    </>
                ) : null
            }
            {
                data.options.sig.active && (map === 'gtaMap' ? <MapGta
                    setMapObject={setMapObject}
                    mini={true}
                    mapType={selectedGtaMap}
                /> : <MapWorld
                    setMapObject={setMapObject}
                    mini={true}
                />)
            }
        </div>
    );
};

export default Sig;
